// extracted by mini-css-extract-plugin
export default {"userRestrictedContainer":"UserRestrictedView-module__userRestrictedContainer--Ootl2","backToAllIssuesButton":"UserRestrictedView-module__backToAllIssuesButton--pt4aq"};